import { httpClient } from '@/app/libs';

interface CreatePanelParams {
  deviceCode: string | null;
  groupName: string | null;
}

interface CreatePanelResponse {
  objeto: { codigoPainel: string };
}

export async function createPanel({ deviceCode, groupName }: CreatePanelParams) {
  const { objeto } = await httpClient.post<CreatePanelResponse>(
    '/paineis',
    { codigoDispositivo: deviceCode, nomeGrupo: groupName },
    {
      safeErrorStatus: [401],
    },
  );

  return objeto.codigoPainel;
}
